<template>
    <div>

        <div class="title-class text-uppercase">
            <a :class="{'font-weight-bold text-dark': !selectedStyle}" class="title-class-link text-secondary" href="javascript:void(0);" @click="removeSelectedStyle()">
                Tous les Styles
            </a>
        
        </div>

        <div v-for="(style, index) in styles" :key="index" class="title-class text-uppercase">
        <a :class="{'font-weight-bold text-dark': selectedStyle && style.id == selectedStyle.id}" class="title-class-link text-secondary" href="javascript:void(0);" @click="selectStyle(style)">
            {{ style.name }}
        </a>
    </div>


    </div>
    
</template>
<script>
export default {
    name: "FilterStyleComponent",
    props: {
        styles: Array,
        propSelectedStyle: Object
    },
    data() {
        return {
            selectedStyle: null,
        };
    },

    mounted() {

        if(this.propSelectedStyle) {
            this.selectedStyle = this.styles.find(style => style.id == this.propSelectedStyle.id);
            this.$emit('select-init', this.selectedStyle);
        }
    },

    computed: {

    },
    methods: {
        selectStyle(style) {
            this.selectedStyle = style;
            this.$emit('style-selected', this.selectedStyle);
        },

        removeSelectedStyle() {
            if (this.selectedStyle == null) {
                return;
            }

            this.selectStyle(null);
        },
    },
};
</script>
  
<style scoped>
.title-class {
    font-size: 14px;
    color: #807e7e;
    /*font-family: Inter;*/
    text-align: left;
    /*text-decoration: underline;*/
    margin-bottom: 10px;
    margin-left: 10%;
    cursor: pointer;
}



.title-class-link:hover {
    color: #121212;
    border-bottom: 2px solid #000;
}
</style>
